"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBoxShadow = void 0;
var styled_components_1 = require("styled-components");
var escapeCss_1 = __importDefault(require("../../helperFunctions/escapeCss"));
var setBoxShadow = function (property) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-box-shadow: ", ";\n  -moz-box-shadow: ", ";\n  box-shadow: ", ";\n"], ["\n  -webkit-box-shadow: ", ";\n  -moz-box-shadow: ", ";\n  box-shadow: ", ";\n"])), escapeCss_1.default(property), escapeCss_1.default(property), escapeCss_1.default(property)); };
exports.setBoxShadow = setBoxShadow;
var templateObject_1;
//# sourceMappingURL=shadow.js.map